import Text from './TextField';
import Image from './ImageField';
import Index from './IndexField';
import Section from './SectionField';
import Editor from './EditorField';
export const Field = {
    Text,
    Image,
    Index,
    Section,
    Editor
};
